import { type SortDirectionDto } from '../../dtos/sort-direction.dto';
import { type SortDirection } from '../../models/sort-direction';
import { reverseRecord } from '../../utils/public-api';

const SORT_DIRECTION_MAP_FROM_DTO: Readonly<Record<SortDirectionDto, SortDirection>> = {
  '+': 'asc',
  '-': 'desc',
};

const SORT_DIRECTION_MAP_TO_DTO = reverseRecord(SORT_DIRECTION_MAP_FROM_DTO);

/** Sort direction mapper. */
export namespace SortDirectionMapper {

  /**
   * Converts DTO direction to model value.
   * @param sortDirectionDto Sort direction DTO value.
   */
  export function fromDto(sortDirectionDto: SortDirectionDto): SortDirection {
    return SORT_DIRECTION_MAP_FROM_DTO[sortDirectionDto];
  }

  /**
   * Converts model direction to DTO value.
   * @param sortDirection Sort direction model value.
   */
  export function toDto(sortDirection: SortDirection): SortDirectionDto {
    return SORT_DIRECTION_MAP_TO_DTO[sortDirection];
  }
}
